export default function zaokragl(liczba, liczbaMiejsc) {
  var potega = 2
  if (liczbaMiejsc) potega = liczbaMiejsc

  var result = liczba * Math.pow(10, potega)
  result = parseFloat(result.toFixed())
  result = result / Math.pow(10, potega)
  return result
}
